import * as v from 'valibot';
import Ajax from '../util/ajax';
import { nexaReceiverSchema } from '../types/NexaReceiver';
import { nexaReceiverAdded } from '../reducers/nexaReceiversSlice';
export function createNexaReceiver(r, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/nexa-receiver/create';
        const obj = Object.assign(Object.assign({}, r), { codes: JSON.stringify(r.codes) });
        ajax.post(url, obj, data => {
            const res = v.safeParse(nexaReceiverSchema, data);
            if (res.success) {
                dispatch(nexaReceiverAdded(res.output));
                okCallback();
            }
            else {
                console.error(v.summarize(res.issues));
                if (errorCallback != undefined) {
                    errorCallback();
                }
            }
        });
    };
}
